const amount = (value) => `$${value.toLocaleString('en-US')}`;

// Expected volume in MXN, mirrors the account tier thresholds.
const leadTiers = [
    { value: 1, name: 'Nivel 1', profile: 'Pequeño negocio', min_amount: 10000, max_amount: 100000 },
    { value: 2, name: 'Nivel 2', profile: 'Pyme en crecimiento', min_amount: 100000, max_amount: 500000 },
    { value: 3, name: 'Nivel 3', profile: 'Pyme premium', min_amount: 500000, max_amount: 2000000 },
    { value: 4, name: 'Nivel 4', profile: 'Mediana empresa', min_amount: 2000000, max_amount: 5000000 },
    { value: 5, name: 'Nivel 5', profile: 'Gran empresa', min_amount: 5000000, max_amount: null },
].map((tier) => ({
    ...tier,
    range: tier.max_amount
        ? `${amount(tier.min_amount)} – ${amount(tier.max_amount)}`
        : `${amount(tier.min_amount)}+`,
    label: `${tier.name} · ${tier.profile}`,
}));

const findTier = (value) => leadTiers.find((tier) => tier.value === Number(value)) || null;

export const leadTierLabel = (value) => findTier(value)?.name || '';

// The lower bound is the amount the sales team commits to for a tier.
export const leadTierAmount = (value) => findTier(value)?.min_amount || 0;

export const leadsExpectedAmount = (leads) => leads.reduce(
    (total, lead) => total + leadTierAmount(lead.tier),
    0
);

export default leadTiers;
